export const animConfig = {
  DELAY_AFTER_READY: 2,
};
export const menus = ['about', 'works', 'contact'];

export const lightState = {
  helper: false,
};

export const boxState = {
  color: '#fff',
  metalness: 0,
  roughness: 0,
};

export const glassState = {
  thickness: 5,
  roughness: 0,
  clearcoat: 1,
  clearcoatRoughness: 0,
  transmission: 1,
  ior: 1.25,
  envMapIntensity: 25,
  color: '#fff',
  attenuationTint: '#ffe79e',
  attenuationDistance: 0,
};

export const contents = {
  meta: {
    title: 'Neon Arts. Taisho Ichikawa',
    description: `Neon Arts. Taisho Ichikawa`,
    ogp: `https://www.electrodeart.com/OGP.jpg`,
    favicon: {
      ico: '/favicon.ico',
      png16: '/favicon-16x16.png',
      png32: '/favicon-32x32.png',
      appleTouchIcon: '/apple-touch-icon.png',
      safariPinnedTab: '/safari-pinned-tab.svg',
      msTile: '/mstile-150x150.png',
    },
  },
  works: [
    {
      id: 0,
      titleEn: 'Campbell’s Banana',
      titleJp: '',
      // ART:0, Client:1
      tag: 0,
      thumb: '/images/posts/2019_campbells/2019_campbells_00.jpg',
      movie: '',
      year: '2019',
      pjinfo: 'exhibition',
      descriptionEn: 'Works exhibited at the "Banana Night" art event',
      descriptionJp: 'アートイベント「バナナナイト」出展作品',
      images: [
        '/images/posts/2019_campbells/2019_campbells_00.jpg',
        '/images/posts/2019_campbells/2019_campbells_01.jpg',
        '/images/posts/2019_campbells/2019_campbells_02.jpg',
      ],
    },
    {
      id: 1,
      titleEn: 'Gampeki Music Festival neon sign',
      titleJp: '「岩壁音楽祭」ネオンサイン',
      // ART:0, Client:1
      tag: 1,
      thumb: '/images/posts/2019_gampeki/2019_gampeki_00.jpg',
      year: '2019',
      pjinfo: 'event,order work',
      descriptionEn: 'Neon sign for "Rock Wall Music Festival" music event',
      descriptionJp: 'ライブイベント「岩壁音楽祭」のネオンサイン',
      images: [
        '/images/posts/2019_gampeki/2019_gampeki_00.jpg',
        '/images/posts/2019_gampeki/2019_gampeki_01.jpg',
      ],
    },
    {
      id: 2,
      titleEn: 'Neon Flower',
      titleJp: '',
      // ART:0, Client:1
      tag: 0,
      thumb: '/images/posts/2019_neonflower/2019_neonflower_00.jpg',
      year: '2019',
      pjinfo: 'exhibition',
      descriptionEn: 'Neon and dried flower sign base',
      descriptionJp: '',
      images: [
        '/images/posts/2019_neonflower/2019_neonflower_00.jpg',
        '/images/posts/2019_neonflower/2019_neonflower_01.jpg',
        '/images/posts/2019_neonflower/2019_neonflower_02.jpg',
        '/images/posts/2019_neonflower/2019_neonflower_03.jpg',
        '/images/posts/2019_neonflower/2019_neonflower_04.jpg',
      ],
    },
    {
      id: 3,
      titleEn: 'Vase neon sign',
      titleJp: 'Vase ネオンサイン',
      // ART:0, Client:1
      tag: 1,
      thumb: '/images/posts/2019_vase/2019_vase_00.jpg',
      year: '2019',
      pjinfo: 'order work',
      descriptionEn: 'Neon sign for select store “Vase“/ Kamimeguro, Meguro-ku, Tokyo',
      descriptionJp: 'セレクトショップ 「Vase」のネオンサイン / 東京都目黒区上目黒',
      images: [
        '/images/posts/2019_vase/2019_vase_00.jpg',
        '/images/posts/2019_vase/2019_vase_01.jpg',
        '/images/posts/2019_vase/2019_vase_02.jpg',
      ],
    },
    {
      id: 4,
      titleEn: 'NONAME neon sign',
      titleJp: 'NONAME ネオンサイン',
      // ART:0, Client:1
      tag: 1,
      thumb: '/images/posts/2020_noname/2020_noname_00.jpg',
      year: '2020',
      pjinfo: 'order work',
      descriptionEn: 'Neon sign of cafe & bar "NONAME" / Utsunomiya, Tochigi / Logo Designing',
      descriptionJp: 'カフェ&バー「NONAME」のネオンサイン / 栃木県宇都宮市 / ロゴデザイン設計',
      images: [
        '/images/posts/2020_noname/2020_noname_00.jpg',
        '/images/posts/2020_noname/2020_noname_01.jpg',
        '/images/posts/2020_noname/2020_noname_02.jpg',
      ],
    },
    {
      id: 5,
      titleEn: 'Distortion',
      titleJp: '',
      // ART:0, Client:1
      tag: 0,
      thumb: '/images/posts/2020_distortion/2020_distortion_00.jpg',
      year: '2022',
      pjinfo: 'private work',
      descriptionEn:
        'Neon tube viewed through a filter that detects distortion of the glass.Experimenting with variations of the "drawing with light" technique.',
      descriptionJp:
        'ガラスの歪みを検知するフィルターを通じて見たネオン管。「光で描画する」という手法を拡張する。',
      images: [
        '/images/posts/2020_distortion/2020_distortion_00.jpg',
        '/images/posts/2020_distortion/2020_distortion_01.jpg',
        '/images/posts/2020_distortion/2020_distortion_02.jpg',
        '/images/posts/2020_distortion/2020_distortion_03.jpg',
        '/images/posts/2020_distortion/2020_distortion_04.jpg',
      ],
    },
    {
      id: 6,
      titleEn: 'Argon Dance',
      titleJp: 'アルゴンダンス',
      // ART:0, Client:1
      tag: 0,
      thumb: '/images/posts/2021_argondance/2021_argondance_00.jpg',
      year: '2021',
      pjinfo: 'private work',
      descriptionEn: 'No description',
      descriptionJp: '',
      images: [
        '/images/posts/2021_argondance/2021_argondance_00.jpg',
        '/images/posts/2021_argondance/2021_argondance_01.jpg',
      ],
    },
    {
      id: 7,
      titleEn: 'Ghost Neon Sign, shared atelier ',
      titleJp: 'シェアアトリエ Ghost ネオンサイン',
      // ART:0, Client:1
      tag: 1,
      thumb: '/images/posts/2021_ghost/2021_ghost_00.jpg',
      year: '2021',
      pjinfo: 'order work',
      descriptionEn: 'Neon sign of shared atelier "Ghost" / Yotsugi, Katsushika-ku, Tokyo',
      descriptionJp: 'シェアアトリエ「Ghost」のネオンサイン/ 東京都葛飾区四つ木',
      images: [
        '/images/posts/2021_ghost/2021_ghost_00.jpg',
        '/images/posts/2021_ghost/2021_ghost_01.jpg',
        '/images/posts/2021_ghost/2021_ghost_02.jpg',
      ],
    },
    {
      id: 8,
      titleEn: '"Chim↑Pom from Smappa! Group" logo neon sign',
      titleJp: '"Chim↑Pom from Smappa! Group" ロゴネオンサイン',
      // ART:0, Client:1
      tag: 1,
      thumb: '/images/posts/2022_chimpom/2022_chimpom_00.jpg',
      year: '2022',
      pjinfo: 'order work',
      descriptionEn:
        'Chim↑Pom from Smappa! Group logo neon sign / @ ANOMALY Gallery / April 27, 2022 (Wed) - June 4, 2022 (Sat)',
      descriptionJp:
        'Chim↑Pom from Smappa! Group ロゴネオンサイン / 個展「Chim↑Pom from Smappa!Group」 / @ANOMALY Gallery / 2022年4月27日 (水) - 2022年6月4日 (土)',
      images: [
        '/images/posts/2022_chimpom/2022_chimpom_00.jpg',
        '/images/posts/2022_chimpom/2022_chimpom_01.jpg',
        '/images/posts/2022_chimpom/2022_chimpom_02.jpg',
      ],
    },
    {
      id: 9,
      titleEn: '3DCG Neon typography and graphics',
      titleJp: '3DCGネオンタイポグラフィ&グラフィック',
      // ART:0, Client:1
      tag: 0,
      thumb: '/images/posts/2021_3dtypography/2021_3dtypography_00.jpg',
      year: '2021',
      pjinfo: 'private work',
      descriptionEn: '3DCG Neon typography and graphics',
      descriptionJp: '3DCGネオンタイポグラフィ&グラフィック',
      images: [
        '/images/posts/2021_3dtypography/2021_3dtypography_00.jpg',
        '/images/posts/2021_3dtypography/2021_3dtypography_01.jpg',
        '/images/posts/2021_3dtypography/2021_3dtypography_02.jpg',
      ],
    },
    {
      id: 10,
      titleEn: 'Toy Neon',
      titleJp: 'トイネオン / 3DCGグラフィックワーク',
      // ART:0, Client:1
      tag: 0,
      thumb: '/images/posts/2022_toyneon/2022_toyneon_00.jpg',
      year: '2021',
      pjinfo: 'private work',
      descriptionEn: 'Toy neon / 3DCG graphic works',
      descriptionJp: 'トイネオン / 3DCGグラフィックワーク',
      images: [
        '/images/posts/2022_toyneon/2022_toyneon_00.jpg',
        '/images/posts/2022_toyneon/2022_toyneon_01.jpg',
        '/images/posts/2022_toyneon/2022_toyneon_02.jpg',
        '/images/posts/2022_toyneon/2022_toyneon_03.jpg',
      ],
    },
    {
      id: 11,
      titleEn: '"Life Line"/ LUMINE meets ART AWARD2020-2021',
      titleJp: '「Life Line」/ ルミネミーツアートアワード2020-2021',
      // ART:0, Client:1
      tag: 0,
      thumb: '/images/posts/2021_lifeline/2021_lifeline_00.jpg',
      year: '2021',
      pjinfo: 'exhibition',
      descriptionEn:
        'LUMINE Meets Art Aword 2020-2021 Entries. The work won the Audience Award. / A picture of an everyday scene is drawn with a special line by a neon sign. I reaffirmed the appreciation of ordinary life, forced to change by the coronavirus.',
      descriptionJp:
        'LUMINE Meets Art Aword 2020-2021 オーディエンス賞受賞作品。/日常のシーンを切り取った絵を、ネオンサインよる特別な線で描く。コロナウイルスで変化を強いられた、普段の生活のありがたみを再認識する。',
      images: [
        '/images/posts/2021_lifeline/2021_lifeline_00.jpg',
        '/images/posts/2021_lifeline/2021_lifeline_01.jpg',
        '/images/posts/2021_lifeline/2021_lifeline_02.jpg',
      ],
    },
    {
      id: 12,
      titleEn: 'Distortion @SICF23 SPIRAL omotesando',
      titleJp: 'Distortion @SICF23 SPIRAL 表参道',
      // ART:0, Client:1
      tag: 0,
      thumb: '/images/posts/2022_distortion/2022_distortion_00.jpg',
      year: '2022',
      pjinfo: 'exhibition',
      descriptionEn:
        'An experimental work that reveals the aesthetics and emotionality that reside in events that would normally be overlooked, exhibited at SICF23.',
      descriptionJp:
        'distrotion - ねじれ、ひずみ。普段看過されてしまうような事象に宿る、審美性、情緒性を表出させる。SICF23出展。',
      images: [
        '/images/posts/2022_distortion/2022_distortion_00.jpg',
        '/images/posts/2022_distortion/2022_distortion_01.jpg',
        '/images/posts/2022_distortion/2022_distortion_02.jpg',
        '/images/posts/2022_distortion/2022_distortion_03.jpg',
        '/images/posts/2022_distortion/2022_distortion_04.jpg',
      ],
    },
    {
      id: 13,
      titleEn: 'Kawakyu Art Exibition 2022 ”In a Dream”',
      titleJp: 'Kawakyu Art Exibition 2022 「夢中」',
      // ART:0, Client:1
      tag: 0,
      thumb: '/images/posts/2022_kawakyu/2022_kawakyu_01.jpg',
      year: '2022',
      pjinfo: 'exhibition',
      descriptionEn:
        'Works exhibited in "Kawakyu Art Exibition 2022: A Dream That Exists". Residence program at Hotel Kawakyu, Wakayama. Jury recommended artist.',
      descriptionJp:
        '「Kawakyu Art Exibition 2022 実在する夢」 の出展作品。和歌山県ホテル川久で行われたレジデンスプログラム。審査員推薦アーティスト。',
      images: [
        '/images/posts/2022_kawakyu/2022_kawakyu_01.jpg',
        '/images/posts/2022_kawakyu/2022_kawakyu_00.jpg',
        '/images/posts/2022_kawakyu/2022_kawakyu_02.jpg',
      ],
    },
    {
      id: 14,
      titleEn: '"Diffusion" Solo Exhibition @DiEGO omotesando',
      titleJp: '"Diffusion" 個展 @DiEGO 表参道',
      // ART:0, Client:1
      tag: 0,
      thumb: '/images/posts/2023_diffusion/2023_diffusion_00.jpg',
      year: '2023',
      pjinfo: 'exhibition',
      descriptionEn:
        '"Stable diffusion" is one of the image-generating AI models. In Stable diffusion, a model called the diffusion model is used. It is a program that gradually removes noise from noisy images to create clean ones. When illuminating neon tubes, it is necessary to create a high vacuum inside the tube, and the pump used at that time is called a "diffusion pump." Heated oil vaporizes, and high vacuum is obtained due to its movement. Diffusion in each context is a completely different function. However, the word "diffusion" connects the subtle phenomena and mystique that are occurring in both cases. Also, I was intrigued by the various meanings of "diffusion" and poetic associations such as particles dissipating into nothingness. In this exhibition, based on images generated by Stable diffusion, we will present neon artworks expressing the phenomenon of "diffusion" inherent in neon signs and their poetic nuances through a new approach.',
      descriptionJp:
        '画像生成AIの一つである「Stable diffusion」。table diffusionでは、diffusion Model(拡散モデル）と呼ばれるモデルが使われています。ノイズ画像から少しづつノイズを取り除き、綺麗な画像を制作するプログラムです。ネオン管を光らせる際には、管の中に高真空を作る必要がありますが、その時に用いるポンプは「拡散ポンプ」と呼ばれます。熱した油が蒸気となり、その運動によって高い真空度が得られます。それぞれの文脈における拡散は、機能は全く違うものです。が、両者で起こっている微細な現象と神秘性が「拡散」という言葉でつながっていること。また、「拡散」が用いられる多様な意味、粒子となって立ち消えていくといった詩的な連想に興味をかきたてられました。本展では、Stable diffusionで生成した「neon art」の画像を元に、ネオンサインで必然的に扱う光を「拡散」する現象と詩的なニュアンスを通し、新たなアプローチで表現したネオン作品を発表いたします。',
      images: [
        '/images/posts/2023_diffusion/2023_diffusion_00.jpg',
        '/images/posts/2023_diffusion/2023_diffusion_01.jpg',
        '/images/posts/2023_diffusion/2023_diffusion_02.jpg',
        '/images/posts/2023_diffusion/2023_diffusion_03.jpg',
        '/images/posts/2023_diffusion/2023_diffusion_04.jpg',
        '/images/posts/2023_diffusion/2023_diffusion_05.jpg',
      ],
    },
    {
      id: 15,
      titleEn: 'Light Ways @SICF25 SPIRAL omotesando',
      titleJp: 'Light Ways @SICF25 SPIRAL 表参道',
      // ART:0, Client:1
      tag: 0,
      thumb: '/images/posts/2024_lightways/2024_lightways_00.jpg',
      year: '2024',
      pjinfo: 'exhibition',
      descriptionEn:
        'The title "Light Ways" plays on words, using "light," which is a homophone for "right" when pronounced in Japanese.In creating this piece, I view neon as a light source from both scientific and artistic perspectives. At the same time, expressing neon as the main focus also depends on the inherent beauty of natural phenomena and a nostalgia for the past. This complex context is likened to flickering light, positioning this work as a process in which I explore what is the "right path" for myself.',
      descriptionJp:
        '「Light Ways」というタイトルは、「right（正しい）」と日本語読みで同音異義語である「light（光）」を用いた言葉遊の表現です。ネオンという光源を、科学技術・芸術双方の立場から俯瞰して作品作りを進める一方で、ネオンを「絵の具」として扱うことは自然現象が持つ原初の美しさや、過去の郷愁に依存することでもあります。そうした複雑な内情を揺れる光になぞらえながら、今回の作品を自分にとっての「正しい道」を探る過程として位置づけています。',
      images: [
        '/images/posts/2024_lightways/2024_lightways_00.jpg',
        '/images/posts/2024_lightways/2024_lightways_01.jpg',
        '/images/posts/2024_lightways/2024_lightways_02.jpg',
        '/images/posts/2024_lightways/2024_lightways_03.jpg',
      ],
    },
  ],
};
